import React from 'react';
import { BookOpenIcon, AppleIcon, StethoscopeIcon } from 'lucide-react';
export function SolutionSection() {
  const features = [{
    icon: BookOpenIcon,
    title: 'Educación práctica',
    description: 'Para padres y cuidadores basada en evidencia científica',
    image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=400'
  }, {
    icon: AppleIcon,
    title: 'Nutrición antiinflamatoria',
    description: 'Basada en ciencia para optimizar la biología familiar',
    image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=400'
  }, {
    icon: StethoscopeIcon,
    title: 'Acceso guiado',
    description: 'A especialistas biomédicos y terapias integradas',
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-180">
      <div className="max-w-6xl mx-auto" data-id="element-181">
        <h2 className="text-3xl sm:text-4xl font-bold text-dark text-center mb-12" data-id="element-182">
          Nuestra Solución
        </h2>
        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-183">
          {features.map((feature, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl hover:scale-[1.03] transition-all duration-300" data-id="element-184">
              <img src={feature.image} alt={feature.title} className="w-full h-[200px] object-cover" data-id="element-185" />
              <div className="p-8" data-id="element-186">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-6" data-id="element-187">
                  <feature.icon className="w-8 h-8 text-primary" data-id="element-188" />
                </div>
                <h3 className="text-xl font-bold text-dark mb-3" data-id="element-189">
                  {feature.title}
                </h3>
                <p className="text-gray-600" data-id="element-190">{feature.description}</p>
              </div>
            </div>)}
        </div>
        <div className="text-center" data-id="element-191">
          <p className="text-2xl font-bold text-dark max-w-3xl mx-auto" data-id="element-192">
            No tratamos partes aisladas. Organizamos el sistema completo.
          </p>
        </div>
      </div>
    </section>;
}